import usePageMetadata from '@hooks/usePageMetadata'

const useIsInSportArticle = (): boolean => {
  const pageMetadata = usePageMetadata()
  return pageMetadata.url.includes('/sport/')
}

export default useIsInSportArticle
